import { useCallback, useState } from "react";
import { postApiJson } from "../services/api";

export interface UseFeedbackOptions {
  inputText?: string;
  outputText?: string;
}

export interface FeedbackPayload extends Record<string, unknown> {
  choice: string;
  body: string;
  type: string;
  contact: string;
  content: string;
  result: string;
}

export function useFeedback({ inputText = "", outputText = "" }: UseFeedbackOptions) {
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [details, setDetails] = useState("");
  const [contact, setContact] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const buildPayload = useCallback((): FeedbackPayload => {
    return {
      choice: "no",
      body: details,
      type: selectedTypes[0] || "",
      contact: contact,
      content: inputText,
      result: outputText,
    };
  }, [contact, details, inputText, outputText, selectedTypes]);

  const submit = useCallback(async () => {
    if (isSubmitting) return false;
    setIsSubmitting(true);
    try {
      const payload = buildPayload();
      await postApiJson<{ message: string }>("/ratings", payload);
      setSelectedTypes([]);
      setDetails("");
      setContact("");
      return true;
    } catch {
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, [buildPayload, isSubmitting]);

  return {
    // state
    selectedTypes,
    setSelectedTypes,
    details,
    setDetails,
    contact,
    setContact,
    isSubmitting,
    // actions
    submit,
  };
}


